import store from '@/store'
import $ from 'jquery'
import api from '@/api/Api'
import misc from './misc'
import _ from 'lodash'
import md5 from 'js-md5'
import { programs } from '@/data'

export const maintenanceSettings = (interimAccess, forceFetch) => {
    let wait = $.Deferred()
    
    if(!forceFetch) {
        let data = store.getters['api/maintenance']
        
        if(!$.isEmptyObject(data))
            return wait.resolve(data).promise()
    }
    
    api.get('/Maintenance/get', { systemCode: 'peerOnline' }).then((r) => {
        if(interimAccess && r.data.maintenance === 2)
            r.data.maintenance = 0
        
        store.dispatch('api/setMaintenanceSettings', r.data)
        return wait.resolve(r.data).promise()
    })
    
    return wait.promise()
}

export const loadCountries = () => {
    let wait = $.Deferred()
    
    let cache = getCountries()
    
    if(!$.isEmptyObject(cache))
        return wait.resolve(true).promise()
    
    api.get('/Common/getCountriesAndStates').then((r) => {
        store.dispatch('peer/countriesInfo', r.data)
        return wait.resolve(true).promise()
    })
    
    return wait.promise()
}

export const getCountries = () => {
    return store.getters['peer/countries']
}

export const getCountryName = (c) => {
    let data = getCountries()
    return data[c] ?data[c] :c
}

export const getStates = (c) => {
    return store.getters['peer/states'](c)
}

export const getStateName = (c, s) => {
    if(!s)
        return s
    
    let data = getStates(c)
    
    while(s.length < 3)
        s += ' '
    
    return data[s] ?data[s] :$.trim(s)
}

export const postalCodeValidate = (data) => {
    let wait = $.Deferred()
    
    data = $.extend(true, {}, {
        country: '',
        state: '',
        postalCode: ''
    }, data)
    
    $.each(data, (k, v) => {
        data[k] = $.trim(v)
    })
    
    let cache = store.getters['peer/postalCodeCache'](data)
    
    if(cache)
        return wait.resolve(cache).promise()
    
    api.post('/Validate/postalCode?hash=true', data).then(
        (r) => {
            store.dispatch('peer/postalCodeCache', {
                input: data,
                output: r.data
            })
            
            return wait.resolve(r.data).promise()
        },
        (r) => {
            return wait.reject(api.getError(r)).promise()
        }
    )
    
    return wait.promise()
}

export const getRatingSystems = () => {
    return [{
        label: 'PEER v2.0',
        value: 'peer.v2_0'
    }]
}

export const getRatingSystem = (shortCode) => {
    let data = store.getters['peer/ratingSystems']
    
    if(!shortCode)
        shortCode = 'peer.v2_0'
    
    shortCode = shortCode.split('.')
    
    $.each(shortCode, (k, v) => {
        if(!data[v])
            return {}
        else
            data = data[v]
    })
    
    return data.code ?{
        code: data.code,
        name: data.name
    } :{}
}

export const getAnticipatedTypes = (program) => {
    return store.getters['peer/anticipatedTypes'](program)
}

export const getOwnerTypes = () => {
    return store.getters['peer/ownerTypes']
}

export const getTeamRoles = () => {
    return store.getters['peer/teamRoles']
}

export const environment = () => {
    return store.getters['api/environment']
}

export const serverTime = () => {
    let wait = $.Deferred()
    
    $.get(apiBaseDomain()+'/Common/currentTime').then((r) => {
        return wait.resolve(parseInt(r)).promise()
    }).fail(() => {
        return wait.resolve(new Date().getTime()).promise()
    })
    
    return wait.promise()
}

export const unitTypSuffix = (unitType) => {
    return unitType === 'SI' ?'sq m' :'sq ft'
}

export const apiFileDelete = (fileId) => {
    let wait = $.Deferred()
    
    api.delete('/Files/delete', { ids: fileId }, true).then(
        (r) => {
            return wait.resolve(r).promise()
        },
        (r) => {
            return wait.reject(api.getError(r)).promise()
        }
    )
    
    return wait.promise()
}

export const apiFileDownload = (fileId) => {
    let wait = $.Deferred()
    
    misc.blockScreen('Preparing download. please wait...')
    
    api.get('/Files/getDownloadUrl', { ids: fileId }).then(
        (r) => {
            if(!r.data.downloadUrl || !r.data.downloadUrl[fileId])
                misc.notify('E', 'Download link not found!', 'Error')
            else
                misc.download(r.data.downloadUrl[fileId])
            
            setTimeout(() => {
                misc.releaseScreen()
            }, 1000)
            
            return wait.resolve(true).promise()
        },
        (r) => {
            misc.releaseScreen()
            misc.notify('E', api.getError(r))
            return wait.reject(false).promise()
        }
    )
    
    return wait.promise()
}

export const apiFileUpload = (params, data) => {
    let wait = $.Deferred()
    
    wait.notify({
        status: 'started'
    })
    
    api.post('/Files/upload', data, true, {
        params: params,
        onUploadProgress: (e) => {
            let completed = Math.round((e.loaded * 100) / e.total)
            
            if(completed < 100) {
                wait.notify({
                    status: 'uploading',
                    completed: Math.round((e.loaded * 100) / e.total)
                })
            }
            else {
                wait.notify({
                    status: 'processing'
                })
            }
        }
    }, api.CONTENT_TYPE_MULTI_PART).then(
        (r) => {
            return wait.resolve(r.data).promise()
        },
        (r) => {
            return wait.reject(api.getError(r)).promise()
        }
    )
    
    return wait.promise()
}

export const organizations = _.debounce((query, loading, obj, dataField) => {
    if(query.length < 2)
        return false
    
    loading(true)
    
    api.get('/LEED/organizations', { q: query }).then(
        (r) => {
            if(r.data.result && r.data.result.length)
                obj[dataField] = r.data.result
            else
                obj[dataField] = []
            
            loading(false)
        },
        (r) => {
            misc.notify('E', api.getError(r))
            loading(false)
        }
    )
}, 350)

export const usgbcDomain = () => {
    let domain = store.state.api.forcedEnv.toLowerCase()
    
    if(domain === 'prd')
        domain = 'www'
    
    return 'https://'+domain+'.usgbc.org'
}

export const apiBaseDomain = () => {
    return store.state.api.baseUrl.split('/').slice(0, 3).join('/')
}

export const programName = (returnAs) => {
    let code = store.state.route.path.split('/')[1]
    
    if(returnAs === 'r')
        return code
    else if(returnAs !== 'p')
        return _.startCase(code)
    
    $.each(programs, (k, v) => {
        if(k === code) {
            code = v
            return false
        }
    })
    
    return code
}

export const getProjectTypeName = (type) => {
    let types = {
        PCA: 'Campus',
        PUT: 'Utility',
        PTR: 'Transit'
    }
    
    return (typeof types[type] != 'undefined') ?types[type] :'Unknown'
}

export const formatActivityMsg = (log, isList) => {
    let msg = log.message.replace(/PEER /g, '')
    
    if(isList && log.projectId && log.type) {
        let typeName = getProjectTypeName(log.type)
        
        if(typeName !== 'Unknown')
            msg += ' in '+typeName+' <router-link to="/'+typeName.toLowerCase()+'/details/'+log.projectId+'">'+log.projectId+'</router-link>'
        
        msg = msg.replace('edited '+typeName+' details in '+typeName, 'edited '+typeName+' details for')
        msg = msg.replace('registered new '+typeName+' in '+typeName, 'registered new '+typeName+' ')
    }
    
    let user = store.getters['activity/members']
    
    if(user['BP'+log.memberId]) {
        user = user['BP'+log.memberId]
        msg = user.firstName+' '+user.lastName+' '+msg
    }
    
    return '<span>'+msg+'</span>'
}

export const getActivityLogs = (path, query, isBoot, isList) => {
    let wait = $.Deferred()
    
    let hash = md5($.param({
        path: path,
        query: query
    }))
    
    let payload = $.extend(true, {
        projectIds: ''
    }, query, {
        hash: '',
        timeFrom: '',
        timeTo: ''
    })
    
    let logs = store.getters['activity/logs'](hash)
    
    if(
        logs !== false
            &&
        (
            (!isBoot && logs.noOldLogs)
                ||
            (isBoot && isList && logs.lastCall !== '' && ($.now() - logs.lastCall) < store.getters['activity/cacheTime'])
        )
    ) {
        return wait.resolve({
            logs: logs.data,
            noOldLogs: logs.noOldLogs
        }).promise()
    }
    
    if(store.getters['activity/lastCalled'] === hash && store.getters['activity/cacheTime'] > 0) {
        if(isBoot && store.getters['activity/newLogs'] !== '')
            payload.hash = store.getters['activity/newLogs']
        else if(!isBoot && store.getters['activity/oldLogs'] !== '')
            payload.hash = store.getters['activity/oldLogs']
    }
    else {
        if(logs !== false) {
            if(isBoot && logs.newLogs !== '')
                payload.timeTo = logs.newLogs
            else if(!isBoot && logs.oldLogs !== '')
                payload.timeFrom = logs.oldLogs
        }
    }
    
    api.get('/Project/activityLogs/'+path, payload).done((r) => {
        store.dispatch('activity/'+(isBoot ?'setNewLogs' :'setOldLogs'), $.extend(true, {
            hash: hash
        }, r.data)).then(() => {
            return wait.resolve(store.getters['activity/logEntries'](hash)).promise()
        })
    }).fail((r) => {
        return wait.reject(api.getError(r)).promise()
    })
    
    return wait.promise()
}

export default {
    maintenanceSettings,
    loadCountries, getCountries, getCountryName,
    getStates, getStateName,
    postalCodeValidate,
    getAnticipatedTypes,
    getProjectTypeName,
    getRatingSystem, getRatingSystems,
    getOwnerTypes,
    getTeamRoles,
    unitTypSuffix,
    apiFileDownload, apiFileDelete, apiFileUpload,
    organizations,
    usgbcDomain, apiBaseDomain,
    programName, getActivityLogs, formatActivityMsg,
    serverTime, environment
}
